import { TimelineLite } from 'gsap/TimelineLite';
import { Power4 } from 'gsap/EasePack';
import { SplitText } from '@/assets/lib/SplitText';

export default function paragraph(el) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const splits = new SplitText(elToTween, { type: 'words, lines' });
  el.splitted = true; // eslint-disable-line
  el.instance = splits; // eslint-disable-line

  const tl = new TimelineLite();

  tl.addLabel('start')
    .to(elToTween, 0.01, {
      autoAlpha: 1,
    }, 'start')
    .fromTo(elToTween, 1, {
      rotationZ: 8,
      transformOrigin: 'left',
    }, {
      rotationZ: 0,
      ease: Power4.easeOut,
      zIndex: 10,
      clearProps: 'transform',
    }, 'start+=0.01')
    .staggerFromTo(splits.lines, 1, {
      y: 45,
      skewX: 30,
      autoAlpha: 0,
      transformOrigin: 'center',
    }, {
      y: 0,
      skewX: 0,
      autoAlpha: 1,
      ease: Power4.easeOut,
      zIndex: 10,
      clearProps: 'transform',
    }, 0.1, 'start+=0.01');

  return tl;
}
